import { Attachment } from "@material-ui/icons";
import { Box, Grid, Tooltip, Typography } from "@mui/material";

import { convertDateToDateTimeStringwithDash } from "../../utils/jsUtils";

export const ChatComponent = ({
  userName,
  message,
  type,
  uploadedFiles,
  createdDate,
  withAttachment,
}) => {
  const messageDate = new Date(createdDate);
  return (
    <Box
      className="bx-shadow communication-component"
      sx={{
        minHeight: "120px",
        backgroundColor: "#fff",
        p: 1,
        my: 2,
        ml: type === "Vendor" || type === "VENDOR" ? 5 : 0,
        mr: type === "FC" || type === "Fc" ? 5 : 0,
        borderRadius: 3,
      }}
    >
      <Grid item mx={3} mt={1}>
        <Grid item sx={{ textAlign: "left", mb: 1 }}>
          <>
            <Box display={"flex"}>
              <Box>
                <div style={{ fontSize: "16px", color: "#4d6fa5" }}>
                  {userName}
                </div>
                <div
                  style={{
                    fontSize: "10px",
                  }}
                >
                  <span>
                    {convertDateToDateTimeStringwithDash(messageDate)}
                  </span>
                </div>
              </Box>
              {withAttachment && (
                <Box mx={1}>
                  <Tooltip title="Attachment Included">
                    <Attachment color="primary" />
                  </Tooltip>
                </Box>
              )}
            </Box>
          </>
        </Grid>
        <Grid item textAlign={"left"}>
          <Typography variant="body1" sx={{ color: "gray", fontSize: "13px" }}>
            {message}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
